import React from 'react'
import { ReactSVG } from 'react-svg'

interface SliderRatingProps {
  rating: number;
  onChange: (newRating: number) => void;
}

 const SliderRating: React.FC<SliderRatingProps> = ({ rating, onChange }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newRating = parseInt(event.target.value);
    onChange(newRating);
  };

  React.useEffect(() => {
    const updateSliderStyles = () => {
      const sliders = document.querySelectorAll(
        'input[type="range"].slider-progress'
      ) as NodeListOf<HTMLInputElement>
      sliders.forEach((e) => {
        e.style.setProperty('--value', e.value)
        e.style.setProperty('--min', e.min === '' ? '0' : e.min)
        e.style.setProperty('--max', e.max === '' ? '100' : e.max)
        e.addEventListener('input', () =>
          e.style.setProperty('--value', e.value)
        )
      })
    }

    updateSliderStyles()

    return () => {
      const sliders = document.querySelectorAll(
        'input[type="range"].slider-progress'
      ) as NodeListOf<HTMLInputElement>
      sliders.forEach((e) => {
        e.removeEventListener('input', () =>
          e.style.setProperty('--value', e.value)
        )
      })
    }
  }, [])

  return (
    <div className="rating-container">
      <input
        type="range"
        min="1"
        max="5"
        step="1"
        value={rating}
        onChange={handleChange}
        className="styled-slider slider-progress"
      />
      <div className="rating-container__stars">
        {Array.from({ length: 5 }, (_, i) => i + 1).map((star, i) => (
          <ReactSVG
            key={i}
            src={`/i/svg/rating2.svg`}
            wrapper={'span'}
            className={`rating-container__star ${rating >= star ? '_filled' : ''}`}
          />
        ))}
      </div>
    </div>
  )
}

export default SliderRating
